// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__215ci","title":"Header_title__1NbTG","left":"Header_left__3U9u6","clinicName":"Header_clinicName__1uujp"};